import { ReactNode } from 'react'
import { Box, Stack, LinearProgress } from '@mui/material'
import { useTheme } from '@thriveglobal/thrive-web-leafkit'
import CardImage from './CardImage'

export type CardHeaderProps = {
    imageSrc?: string
    largeImage?: boolean
    progress?: number
    contrastCard?: boolean
    backgroundColor?: string
    topLeftContent?: ReactNode
    topRightContent?: ReactNode
    bottomLeftContent?: ReactNode
    bottomRightContent?: ReactNode
}

export default function CardHeader({
    imageSrc,
    largeImage,
    progress,
    backgroundColor,
    contrastCard,
    topLeftContent,
    topRightContent,
    bottomLeftContent,
    bottomRightContent
}: CardHeaderProps) {
    const theme = useTheme()

    const showLinearProgress = progress !== undefined && progress > 0

    return (
        <CardImage
            imageSrc={imageSrc}
            largeImage={largeImage}
            contrastCard={contrastCard}
            backgroundColor={backgroundColor}
        >
            <Stack
                flexWrap="wrap"
                sx={{
                    height: showLinearProgress ? '90%' : '100%',
                    width: '100%'
                }}
            >
                <Stack
                    justifyContent="flex-start"
                    alignItems="flex-start"
                    sx={{
                        width: '50%',
                        height: '50%',
                        p: theme.spacing(2)
                    }}
                >
                    {topLeftContent}
                </Stack>
                <Stack
                    justifyContent="flex-end"
                    alignItems="flex-start"
                    sx={{
                        width: '50%',
                        height: '50%',
                        p: theme.spacing(2)
                    }}
                >
                    {bottomLeftContent}
                </Stack>
                <Stack
                    justifyContent="flex-start"
                    alignItems="flex-end"
                    sx={{
                        width: '50%',
                        height: '50%',
                        p: theme.spacing(2)
                    }}
                >
                    {topRightContent}
                </Stack>
                <Stack
                    justifyContent="flex-end"
                    alignItems="flex-end"
                    sx={{
                        width: '50%',
                        height: '50%',
                        p: theme.spacing(2)
                    }}
                >
                    {bottomRightContent}
                </Stack>
            </Stack>

            {showLinearProgress && (
                <Box
                    sx={{
                        color: theme.palette.info.main,
                        width: '100%',
                        height: '10%',
                        px: theme.spacing(2),
                        background: `linear-gradient(0deg, ${theme.palette.grey[700]}, transparent)`
                    }}
                >
                    <LinearProgress
                        color="inherit"
                        variant="determinate"
                        value={progress}
                    />
                </Box>
            )}
        </CardImage>
    )
}
